var OdConfig = /** @class */ (function () {
    function OdConfig(url, port, version, fileUrl, downloadFileUrl, dbName, dbLocation, cacheName, cacheEncrypted, jabberUrl, jabberAdminReceiver, jabberAdminSender, jabberAnonymous, jabberConference, defaultLanguage, languages, conversationsApi) {
        this._url = url;
        this._port = port;
        this._version = version;
        this._fileUrl = fileUrl;
        this._downloadFileUrl = downloadFileUrl;
        this._dbName = dbName;
        this._dbLocation = dbLocation;
        this._cacheName = cacheName;
        this._cacheEncrypted = cacheEncrypted;
        this._jabberUrl = jabberUrl;
        this._jabberAdminReceiver = jabberAdminReceiver;
        this._jabberAdminSender = jabberAdminSender;
        this._jabberAnonymous = jabberAnonymous;
        this._jabberConference = jabberConference;
        this._defaultLanguage = defaultLanguage;
        this._languages = languages;
        this._conversationsApi = conversationsApi;
    }
    Object.defineProperty(OdConfig.prototype, "dbName", {
        get: function () {
            return this._dbName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "dbLocation", {
        get: function () {
            return this._dbLocation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "cacheName", {
        get: function () {
            return this._cacheName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "cacheEncrypted", {
        get: function () {
            return this._cacheEncrypted;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "url", {
        get: function () {
            return this._url;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "port", {
        get: function () {
            return this._port;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "version", {
        get: function () {
            return this._version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "fileUrl", {
        get: function () {
            return this._fileUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "downloadFileUrl", {
        get: function () {
            return this._downloadFileUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "jabberUrl", {
        get: function () {
            return this._jabberUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "jabberAdminReceiver", {
        get: function () {
            return this._jabberAdminReceiver;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "jabberAdminSender", {
        get: function () {
            return this._jabberAdminSender;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "jabberAnonymous", {
        get: function () {
            return this._jabberAnonymous;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "jabberConference", {
        get: function () {
            return this._jabberConference;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "defaultLanguage", {
        get: function () {
            return this._defaultLanguage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "languages", {
        get: function () {
            return this._languages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OdConfig.prototype, "conversationsApi", {
        get: function () {
            return this._conversationsApi;
        },
        enumerable: true,
        configurable: true
    });
    return OdConfig;
}());
export { OdConfig };
//# sourceMappingURL=od-config.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/od-config.js
// module id = 147
// module chunks = 14